<template>
    <div>
        <v-card>
            <v-card-text
                class="text-center">
                <v-progress-circular
                    indeterminate
                    v-if="!dataLoaded"
                    color="primary">
                </v-progress-circular>
                <v-form
                    ref="form"
                    v-model="valid"
                    v-if="dataLoaded && !search">
                    <!-- <v-select
                        label="الورشة"
                        :items="workshops"
                        item-text="name"
                        item-value="id"
                        v-model="form.workshop_id">
                    </v-select> -->
                    <v-text-field
                        label="رقم اللوحة"
                        @keypress.enter="submit"
                        v-model="form.truck">
                    </v-text-field>
                    <v-text-field
                        label="السائق"
                        @keypress.enter="submit"
                        v-model="form.driver">
                    </v-text-field>
                    <v-menu
                        v-model="dateOpenMenu"
                        absolute=""
                        :close-on-click="false"
                        :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="تاريخ الدخول"
                                v-on="on"
                                readonly
                                v-model="form.date_enter_range">
                            </v-text-field>
                        </template>
                        <v-card flat>
                            <v-date-picker
                                range
                                show-current
                                v-model="form.date_enter_range">
                            </v-date-picker>
                            <v-card-actions>
                                <v-btn
                                    color="primary"
                                    @click="dateOpenMenu = false">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                    <v-menu
                        v-model="dateCloseMenu"
                        absolute=""
                        :close-on-click="false"
                        :close-on-content-click="false">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                label="تاريخ الخروج"
                                v-on="on"
                                readonly
                                v-model="form.leave_date_range">
                            </v-text-field>
                        </template>
                        <v-card flat>
                            <v-date-picker
                                range
                                show-current
                                v-model="form.leave_date_range">
                            </v-date-picker>
                            <v-card-actions>
                                <v-btn
                                    text
                                    @click="dateCloseMenu = false">OK</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-menu>
                    <v-select
                        label="الحالة"
                        :items="stateSelect"
                        v-model="form.state">
                    </v-select>
                </v-form>
            </v-card-text>
            <v-card-actions
                v-if="!search">
                <v-btn
                   text
                    @click="submit"
                    :loading="submitLoading">
                    بحث
                </v-btn>
                <v-btn
                    text
                    @click="resetForm()">
                    تفريغ الحقول
                </v-btn>
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
    name: "JobcardSearchDialog",

    data() {
        return {
            dataLoaded: false,
            dateOpenMenu: false,
            dateCloseMenu: false,
            submitLoading: false,
            display: false,
            valid: false,
            search: null,
            form: {
                workshop_id: null,
                truck: null,
                dirver: null,
                date_enter_range: [],
                leave_date_range: [],
                state: null
            },
            stateSelect: [
                {text: "مفتوح", value: "OPEN"},
                {text: "مغلق", value: "CLOSED"}
            ]
        }
    },
    computed: {
        ...mapState("workshop", ["workshops"]),
        ...mapState("authentication", ["workshopId"])
    },
    methods: {
        ...mapActions("workshop", ["fetchAll"]),
        ...mapActions("jobcard", ["fetchJobcards"]),
        resetForm() {
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            this.submitLoading = false;
        },
        async submit() {
            this.$emit("search", this.form);
            this.close();
        },
        emitSearch() {
            this.$emit("search", this.form);
        },
        close() {
            this.display = false;
        }
    },
    async created() {
        this.form.workshop_id = this.workshopId;
        this.dataLoaded = true;
    }
}
</script>